<template>
  <div
    class="loading-element fixed top-0 left-0 z-9999 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out"
  >
    <div
      class="absolute top-0 left-0 z-20 h-full w-full bg-black opacity-80"
    ></div>
    <div class="relative z-30 p-10">
      <div
        ref="modal"
        v-click-away="no"
        class="bg-white p-6 focus:outline-none"
        tabindex="0"
        @keyup.esc="no"
      >
        <div class="mb-6">{{ text }}</div>
        <div class="flex">
          <div class="mr-2 w-1/2">
            <ButtonSecondary
              type="button"
              :name="$t('global.defaults.no')"
              @click="no()"
            ></ButtonSecondary>
          </div>
          <div class="ml-2 w-1/2">
            <Button
              type="button"
              :name="$t('global.defaults.yes')"
              @click="yes()"
            ></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import Button from "@/components/utils/Button.vue"; // @ is an alias to /src
import ButtonSecondary from "@/components/utils/ButtonSecondary.vue"; // @ is an alias to /src

@Options({
  components: {
    Button,
    ButtonSecondary,
  },
  emits: ["yes", "no"],
  props: {
    text: String,
  },
  data() {
    return {
      deleting: false,
    };
  },
  mounted() {
    this.$refs.modal.focus();
  },
  methods: {
    yes() {
      this.$emit("yes");
    },
    no() {
      this.$emit("no");
    },
  },
})
export default class ModalDeleteCheck extends Vue {}
</script>
